<template>
  <div class="refresh-container" v-if="openModal">
    <div class="notification-header">
      <button type="button" class="close-refresh-modal" @click="openModal=false;" aria-label="Close">
        <span aria-hidden="true"><i class="fal fa-times fa-sm"></i></span>
      </button>
    </div>
    <div class="notification-body">
      <div class="notification-button">
        <p class="text-center font12">
          An update is available. Please click update below.
        </p>
        <p class="text-center font12"> 
          You can also accept these updates by refreshing your browser at any time.
        </p>
        <p class="text-center"><span class="font10">Not updating may result in errors.</span></p>
      </div>
      <div class="refresh-button text-center">
        <button class="btn btn-primary" @click="reloadApp">Update</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentVersion : localStorage.getItem('api-version'),
      versionChanged: false,
      newVersion: '',
      openModal: false,
    }
  },
  methods: {
    initVersionCheck(frequency = 1000 * 60 * 2) {
      setInterval(() => {
        this.checkVersion();
      }, frequency);
    },
    async checkVersion() {
      this.$store.dispatch("get_version")
      .then((rsp) => {
        this.newVersion     = rsp.data.api_version;
        this.currentVersion = localStorage.getItem('api-version');

        this.versionChanged = this.hasVersionChanged(this.currentVersion, this.newVersion);
        if (this.versionChanged){
          //this.openModal = true;
          this.reloadApp();
          //localStorage.setItem('api-version',this.newVersion);
        }
      })      
    },
    hasVersionChanged(currentVersion, newVersion) {
      if (!currentVersion || currentVersion === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
        return true;
      }

      return currentVersion !== newVersion;
    },
    reloadApp() {
      localStorage.removeItem('api-version');
      window.location.reload();
      localStorage.setItem('api-version',this.newVersion);
    }
  },
  created(){
    this.checkVersion();
    this.initVersionCheck(1000*60*1);
  }
}
</script>